import React from 'react';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import MetaAdsSettings from '@app/components/manage-meta-ads/MetaAdsSettings';

const ManageMetaAds: React.FC = () => {
  return (
    <>
      <PageTitle>Meta Ads Configuration</PageTitle>
      <MetaAdsSettings />
    </>
  );
};

export default ManageMetaAds;
